import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IAbstractPresenter } from '@core/interfaces';
import { IPricesComponent, IPricesPresenter } from './interfaces';
import { hasMultipleSingleProductPrices, hasSingleProductDiscount } from '@features/home/domain';

@Injectable()
export class PricesPresenter 
  extends IAbstractPresenter<IPricesComponent>
  implements IPricesPresenter 
{
  constructor() {
    super();
  }

  dispatchActions(): void {}
  suscribeObservers(): void {}

  shouldShowPrices(): boolean {
    return hasMultipleSingleProductPrices(this.view.pricesFormGroups.length);
  }

  hasDiscount(priceControl: FormGroup): boolean {
    return hasSingleProductDiscount(
      priceControl.get('precio')?.value,
      priceControl.get('specialPriceAmount')?.value
    );
  }
}
